module.exports = __webpack_public_path__ + "img/external-link.e7d34a70.svg";